import apiClient from '../../../core/Api';
import { Activity, ActivityQueryParams } from '../../../data/types/user.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class DashboardService {
  static getUserActivities = async (
    params: ActivityQueryParams
  ): Promise<{ activities: Activity[]; totalCount: number }> =>
    apiClient.get(`${API_BASE_URL}/admin/users/activity`, { params }).then((response) => {
      const { data } = response;
      return data;
    });
}
export default DashboardService;
